/**
 * Legal identity — the single source of truth for every place we have to name the
 * trader (Impressum, privacy policy, terms, landing footer).
 *
 * Chefty trades as a German sole proprietorship (Einzelunternehmen / Gewerbe), so
 * the Impressum names the natural person who owns it — there is no GmbH, hence no
 * managing director and no Handelsregister number. The USt-IdNr. is public; the
 * Steuernummer is NOT published.
 *
 * The same identity is declared to Apple as the EU DSA trader — if any value here
 * changes it must be re-declared in App Store Connect (and Play Console) too.
 *
 * Lives in shared-types (not in a web app) because BOTH the website and the
 * mobile Impressum screen have to show exactly the same identity — and § 5 DDG
 * is not discharged by the store listing, so the app must render it natively and
 * offline. One constant, no drift.
 */
export const LEGAL = {
    /** Brand / trading name. */
    entity: 'Chefty',
    /** Einzelunternehmen — the legally responsible natural person. */
    owner: 'Diana Tereshchenko',
    addressLines: ['Südwestkorso 1', '12161 Berlin', 'Germany'],
    /** n/a — sole proprietorship, not a GmbH. */
    managingDirector: '',
    /** n/a — not entered in the Handelsregister. */
    register: '',
    /** USt-IdNr. per § 27a UStG (public). Do NOT publish the Steuernummer. */
    vatId: 'DE462590461',
    email: 'hello@chefty.app',
    privacyEmail: 'privacy@chefty.app',
    supportEmail: 'support@chefty.app',
    /** Optional, but a recommended "fast means of contact" under § 5 DDG. */
    phone: '',
    /** § 18 (2) MStV. */
    contentResponsible: 'Diana Tereshchenko, address as above',
    /** Competent supervisory authority for DSGVO complaints (seat = Berlin). */
    dpa: {
        name: 'Berliner Beauftragte für Datenschutz und Informationsfreiheit',
        url: 'https://www.datenschutz-berlin.de',
    },
};
/** Single-line address, for prose and the landing footer. */
export const LEGAL_ADDRESS = LEGAL.addressLines.join(', ');
/**
 * Canonical public URLs for the legal pages. The mobile app links out to these
 * (App Review expects Privacy + Terms reachable in-app and beside the paywall),
 * so they must stay in step with the routes registered in apps/client.
 *
 * The imprint is the exception: the app renders it natively and offline as well,
 * because a link is not "permanently available" under § 5 DDG.
 */
export const LEGAL_URLS = {
    site: 'https://chefty.app',
    privacy: 'https://chefty.app/privacy',
    terms: 'https://chefty.app/terms',
    impressum: 'https://chefty.app/impressum',
    deleteAccount: 'https://chefty.app/delete-account',
    support: 'https://chefty.app/support',
};
/**
 * Last substantive revision of the legal pages. Bump whenever the text changes —
 * users are entitled to see when the terms they agreed to were last altered.
 */
export const LEGAL_LAST_UPDATED = '16 September 2026';
//# sourceMappingURL=legal.js.map